<template>
  <div class="ItemMenuToday">
    <router-link
      v-bind:to="{name:'InfoDish',params:{'dishId':Obj.code-1}}"
      class="collection-item avatar"
    >
      <img v-bind:src="Obj.img" v-bind:alt="Obj.name" class="circle">
      <span class="title black-text truncate">{{Obj.name}}</span>
      <p
        class="grey-text"
        style="min-height: 53px;"
        v-if="Obj.desc_min.length > 125"
      >{{Obj.desc_min.substring(0, 125) + '...'}}</p>
      <p class="grey-text" style="min-height: 53px;" v-else>{{Obj.desc_min}}</p>

      <p class="grey-text">
        <span class="clasificacion" v-if="Obj.star > 4.5">
          <input type="radio" value="5" checked>
          <label>&#9733;</label>
          <input type="radio" value="4">
          <label>&#9733;</label>
          <input type="radio" value="3">
          <label>&#9733;</label>
          <input type="radio" value="2">
          <label>&#9733;</label>
          <input type="radio" value="1">
          <label>&#9733;</label>
        </span>
        <span class="clasificacion" v-else-if="Obj.star > 3.5 && Obj.star <= 4.5">
          <input type="radio" value="5">
          <label>&#9733;</label>
          <input type="radio" value="4" checked>
          <label>&#9733;</label>
          <input type="radio" value="3">
          <label>&#9733;</label>
          <input type="radio" value="2">
          <label>&#9733;</label>
          <input type="radio" value="1">
          <label>&#9733;</label>
        </span>
        
        <span class="clasificacion" v-else-if="Obj.star > 2.5 && Obj.star < 3.5">
          <input type="radio" value="5">
          <label>&#9733;</label>
          <input type="radio" value="4">
          <label>&#9733;</label>
          <input type="radio" value="3" checked>
          <label>&#9733;</label>
          <input type="radio" value="2">
          <label>&#9733;</label>
          <input type="radio" value="1">
          <label>&#9733;</label>
        </span>
        <span class="clasificacion" v-else-if="Obj.star > 1.5 && Obj.star < 2.5">
          <input type="radio" value="5">
          <label>&#9733;</label>
          <input type="radio" value="4">
          <label>&#9733;</label>
          <input type="radio" value="3">
          <label>&#9733;</label>
          <input type="radio" value="2" checked>
          <label>&#9733;</label>
          <input type="radio" value="1">
          <label>&#9733;</label>
        </span>
        <span class="clasificacion" v-else-if="Obj.star > 0.5 && Obj.star < 1.5">
          <input type="radio" value="5">
          <label>&#9733;</label>
          <input type="radio" value="4">
          <label>&#9733;</label>
          <input type="radio" value="3">
          <label>&#9733;</label>
          <input type="radio" value="2">
          <label>&#9733;</label>
          <input type="radio" value="1" checked>
          <label>&#9733;</label>
        </span>
        <span class="clasificacion" v-else-if="Obj.star < 0.5">
          <input type="radio" value="5">
          <label>&#9733;</label>
          <input type="radio" value="4">
          <label>&#9733;</label>
          <input type="radio" value="3">
          <label>&#9733;</label>
          <input type="radio" value="2">
          <label>&#9733;</label>
          <input type="radio" value="1">
          <label>&#9733;</label>
        </span>
        Calificación: {{Obj.star}} - {{Obj.votos}} Votos
        <span
          class="btn-floating halfway-fab waves-effect waves-light red darken-4 activator pulse"
        >
          <i class="material-icons">restaurant_menu</i>
        </span>
      </p>
    </router-link>
    <div class="divider"></div>
  </div>
</template>
<script>
import Star from "../../assets/style/star.css";
export default {
  name: "ItemMenuToday",
  props: ["Obj", "index"],
  data() {
    return {
      prop: [
        {
          cateringId: String,
          index: Number,
          Obj: {
            fecha: Date,
            code: Number,
            name: String,
            desc: String,
            ingredientes: String,
            star: Float64Array,
            votos: Number,
            img: String,
            icon: String,
            Comments: [
              {
                fecha: Date,
                user: String,
                email: String,
                comments: String,
                star: Number
              }
            ]
          }
        }
      ]
    };
  }
};
</script>

<style scoped>
.circle {
  width: 90px !important;
  height: 90px !important;
  border-radius: 5% !important;
  left: 10px !important;
}
.collection.with-header .collection-item.avatar {
  padding-left: 110px !important;
}
.collection .collection-item.avatar .title {
  font-size: 14px !important;
}
.collection .collection-item.avatar .grey-text {
  font-size: 12px !important;
}

.collection .collection-item {
  line-height: 1.3rem !important;
  background-color: #f4f4f5 !important;
}
.collection-item.avatar {
  transition: background-color 0.2s;
}

.collection-item.avatar:hover {
  color: #7f0000 !important;
  color: #ffffff !important;
}
.collection-item.avatar:active {
  background-color: #7f0000 !important;
  color: #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/menu/ItemMenuToday.vue